var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"time"},[_vm._v(" "+_vm._s(_vm.hours)),_c('span',{staticClass:"time__delimiter"},[_vm._v(":")]),_vm._v(_vm._s(_vm.minutes)+" "+_vm._s(_vm.date)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }